module.exports = __webpack_public_path__ + "img/dining_room_thumb.de7e86e1.jpg";